import { styled } from "@mui/material/styles";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const LoginLinks = (): React.ReactElement => (
  <LinksContainer>
    <StyledLink data-testid="forgot-password" to="/reset">
      <FormattedMessage id="Login.forgot-password-question" />
    </StyledLink>
    <span>
      <FormattedMessage id="Login.dont-have-account" />
      &nbsp;
      <StyledLink to="/signup">
        <FormattedMessage id="Login.dont-have-account-register" />
      </StyledLink>
    </span>
  </LinksContainer>
);

const LinksContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(2),
}));

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  "&:visited, &:hover, &:focus": {
    color: theme.palette.primary.main,
  },
}));

export { LoginLinks };
